require('./icon-button.js');
require('./dist/infotip/ds6/infotip.css');
